'use client';

import React__default from 'react';

var SuitableIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 20 : _b, _c = _a.height, height = _c === void 0 ? 20 : _c, _d = _a.color, color = _d === void 0 ? '#FFAF00' : _d;
    return (React__default.createElement("svg", { width: width, height: height, viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React__default.createElement("circle", { cx: "12.5", cy: "12.5", r: "12.5", fill: color }),
        React__default.createElement("path", { d: "M13.5 6.25V11.75H19C19 8.7125 16.5375 6.25 13.5 6.25ZM12.5 7.25C9.4625 7.25 7 9.7125 7 12.75C7 15.7875 9.4625 18.25 12.5 18.25C15.5375 18.25 18 15.7875 18 12.75H12.5V7.25Z", fill: "white" })));
};
var SuitableIcon$1 = /*#__PURE__*/ React__default.memo(SuitableIcon);

export { SuitableIcon$1 as default };
//# sourceMappingURL=index.js.map
